import Paginacion from "./Paginacion";

export default function Villanos2(){
    return (
        <div className="villanos">
            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">
                            MAN-BAT
                        </h1>
                        <hr></hr>
                        <p>
                            <strong>Nombre real:</strong> Kirk Langstrom<br></br>
                            <strong>Profesión: </strong>Científico y bioquímico<br></br>
                            <strong>Habilidad: </strong>
                            Fuerza sobrehumana, vuelo y ecolocalización
                        </p>
                        <hr className="w-25"></hr>
                        <p>
                            Kirk Langstrom fue un brillante científico en zoología y 
                            bioquímica. Obsesionado por encontrar una cura para la 
                            sordera que él mismo padecía, desarrolló un suero especial 
                            basado en el sistema de ecolocalización de los murciélagos. 
                            Lamentablemente el experimento acabó de una manera muy 
                            terrible, transformándolo en una criatura monstruosa. 
                        </p>
                        <p>
                            Convertido en una bestia alada que sobrevuela la ciudad, 
                            Langstrom pierde gran parte de su humanidad y actúa guiado 
                            por sus instintos salvajes. A diferencia de otros villanos de 
                            Batman, Man-Bat no busca sembrar caos ni venganza, es el 
                            resultado de un experimento fallido, una pesadilla viviente 
                            en una constante lucha entre su parte humana y la criatura en 
                            la que se convirtió.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                        <img src="/imagenes/man-bat.jpg" className="img-fluid" alt="man-bat"></img>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">
                            MR FREEZE
                        </h1>
                        <hr></hr>
                        <p>
                            <strong>Nombre real: </strong>Victor Fries<br></br>
                            <strong>Profesión: </strong>Científico criogénico<br></br>
                            <strong>Habilidad: </strong>Tecnología criogénica y armas 
                            de hielo
                        </p>
                        <hr className="w-25"></hr>
                        <p>
                            Victor Fries fue un brillante científico especializado en 
                            criogenia, dedicado a encontrar una cura para la enfermedad 
                            terminal de su esposa. Durante uno de sus experimentos 
                            ocurrió un accidente que alteró su cuerpo de forma 
                            irreversible, obligándolo a vivir en temperaturas 
                            extremadamente bajas para poder sobrevivir.
                        </p>
                        <p>
                            Equipado con un traje criogénico y poderosas armas 
                            capaces de congelar cualquier cosa a su alrededor, 
                            se convirtió en uno de los enemigos más singulares de 
                            Batman. A diferencia de muchos criminales de Ciudad Gótica, 
                            sus acciones están motivadas por una obsesión desesperada: 
                            encontrar la forma de salvar a su esposa, sin importar el costo.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                        <img src="/imagenes/mr-freeze.jpg" alt="mr-freeze" className="img-fluid"></img>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">
                            KILLER CROC
                        </h1>
                        <hr></hr>
                        <p>
                            <strong>Nombre real: </strong>Waylon Jones<br></br>
                            <strong>Habilidad: </strong>Fuerza sobrehumana y resistencia 
                            extrema
                        </p>
                        <hr className="w-25"></hr>
                        <p>
                            Waylon Jones nació con una extraña enfermedad que provocó que 
                            su piel desarrollara escamas similares a la de un reptil. 
                            Debido a su apariencia, fue rechazado y maltratado desde niño, 
                            creciendo en un ambiente lleno de violencia que terminó 
                            moldando su carácter.
                        </p>
                        <p>
                            Con el tiempo se convirtió en el criminal conocido como 
                            Killer Croc, una figura brutal que habita en las 
                            alcantarillas de Ciudad Gótica. Dotado de una fuerza 
                            monstruosa, resistencia extraordinaria y una naturaleza 
                            salvaje, Croc es más bestia que criminal, capaz de 
                            enfrentarse físicamente incluso a Batman en combate 
                            directo.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                        <img src="/imagenes/killer-croc.jpg" className="img-fluid" alt="killer-croc"></img>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">
                            THE PENGUIN
                        </h1>
                        <hr></hr>
                        <p>
                            <strong>Nombre real: </strong>Oswald Cobblepot<br></br>
                            <strong>Habilidad: </strong>Experto en crimen organizado
                        </p>
                        <hr className="w-25"></hr>
                        <p>
                            El Pingüino es un villano elegante y calculador de Ciudad 
                            Gótica, conocido por su amor por el dinero, el poder y los 
                            necogios ilícitos. Siempre viste de manera formal, con sombrero 
                            en copa, bastón y traje, lo que le da una apariencia 
                            distinguida, pero bajo esa fachada es un criminal 
                            despiadado que controla su propio imperio delictivo. 
                        </p>
                        <p>
                            Oswald combina inteligencia, astucia y contactos en la 
                            sociedad para llevar a cabo sus planes, utilizando su 
                            bastón como arma o herramienta tecnológica. A diferencia 
                            de otros villanos, no depende de superpoderes, sino de 
                            estrategia, manipulación y recursos, lo que lo convierte 
                            en un enemigo constante y peligroso para Batman.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                        <img src="/imagenes/the-penguin.jpg" className="img-fluid" alt="the-penguin"></img>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">
                            RA'S AL GHUL
                        </h1>
                        <hr></hr>
                        <p>
                            <strong>Alias: </strong>La Cabeza del Demonio<br></br>
                            <strong>Habilidad: </strong>Maestro estratega, experto 
                            en combate y líder de la Liga de los Asesinos
                        </p>
                        <hr className="w-25"></hr>
                        <p>
                            Es uno de los enemigos más peligrosos e inteligentes de Batman. 
                            Como líder de la Liga de los Asesinos busca "equilibrar" el  
                            mundo eliminando la corrupción de la humanidad. A diferencia 
                            de muchos villanos, sus planes suelen tener una escala global 
                            y basados en su "visión radical" de salvar el mundo.
                        </p>
                        <p>
                            Gracias a las Fosas de Lázaro, Ra's ha sobrevivido varios siglos, 
                            lo que le ha permitido acumular poder, experiencia en combate  
                            y conocimiento. Su inteligencia, recursos y su compleja relación 
                            de un enorme respeto hacia Batman, lo convierte en un adversario 
                            único.

                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
                        <img src="/imagenes/ras-al-ghul.png" className="img-fluid" alt="ras-al-ghul"></img>
                    </div>
                </div>
            </div>

            <Paginacion></Paginacion>

        </div>
    )
}